import React from 'react';
import Photo from './Photo';
import PhotosView from './PhotosView';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import RoomPhotosModal from './RoomPhotosModal';
import { Button, Image,ButtonToolbar } from 'react-bootstrap';
import RoomsForm from './RoomsForm';
import noimage1 from '../../../../public/noimage1.jpg'
import { Modal } from 'react-bootstrap';

function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}

class RoomsView extends React.Component {

  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
    this.state = { show: false, selectedRoomType: null,showConfirm:false,del_room_id:0,modalText:'',isRoomtypeView:false };
  }
  handleRemove() {
    this.props.removeRoomType(this.state.del_room_id);
    this.setState({showConfirm:false})
  }
  openModal = idx => {
    const selectedRoomType = this.props.hotel.room_types.find(c => c.id == idx)
    this.setState({
      show: true,
      selectedRoomType,
      isRoomtypeView:false
    })
  };
  openViewModal = idx => {
    const selectedRoomType = this.props.hotel.room_types.find(c => c.id == idx)
    this.setState({
      show: true,
      selectedRoomType,
      isRoomtypeView:true
    })
  };

  closeModal = () => {
    this.setState({
      show: false, selectedRoomType: null,showConfirm:false
    })
  }
  showErrorModal = (id) => {
    this.setState({showConfirm:true,del_room_id:id,modalText:'Are you sure, you want to delete this Room Type?'})
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.selectedRoomType) {
      const selectedRoomType = nextProps.hotel.room_types.find(c => c.id == this.state.selectedRoomType.id)
      this.setState({ selectedRoomType })
    }
  }

  formatRoomTypes = (roomtypes) => {
    if(roomtypes) {
      const roomsList = [];
      roomtypes.forEach(room => {
        roomsList.push(
          <div className="col-md-3" key={room.id}>
            <div className="thumbnail" onClick={() => this.openViewModal(room.id)} >
              {hasPhotos(room.room_photos) ? <Image src={room.room_photos[0].photo} responsive className="hotel-img" /> :
                <Image src={noimage1} responsive className="hotel-img" />}
            </div>
            <div className="caption">
                <h4>{room.room_type}</h4>
                {!this.props.isHotelView && <ul className="hotel-photo-tools">
                  <li><Button onClick={() => this.showErrorModal(room.id)} title="Remove"><i className="fa fa-trash" /></Button></li>
                  <li><Button onClick={() => this.openModal(room.id)} title="edit"><i className="fa fa-pencil" /></Button> </li>
                </ul>
                }
            </div>

          </div>
        )
      })
      return roomsList
    }
    return (
      <div className="col-md-12">
        <h5 className="hotel-highlight">No room types available</h5>
      </div>
    )
  }

  formatRoomTypesView = (roomtypes) => {
    if (roomtypes) {
    const roomsList = [];
    roomtypes.forEach(room => {
      roomsList.push(
        <div className="col-md-3" key={room.id}>
          <div className="thumbnail" onClick={() => this.openViewModal(room.id)} >
            {hasPhotos(room.room_photos) ? <Image src={room.room_photos[0].photo} responsive className="hotel-img" /> :
              <Image src={noimage1} responsive className="hotel-img" />}
            <div>
              <h4>{room.room_type}</h4>
            </div>
          </div>
        </div>
      )
    })
    return roomsList
  }
  return (
    <div className="col-md-12">
      <h5 className="hotel-highlight">No room types available</h5>
    </div>
  )
  }

  render() {
    const roomsList = this.props.isHotelView ? this.formatRoomTypesView(this.props.hotel.room_types) : this.formatRoomTypes(this.props.hotel.room_types);
    return (
      <div>
        {this.props.isHotelView ? 
          <div className="row">
            <div className="col-md-12">
              <h1 className="hotel-detail-subhead">Rooms</h1>
            </div>
          </div>
          : 
          <div className="row">
            <div className="col-md-12">
              <h1 className="hotel-detail-subhead">
                <RoomsForm {...this.props} ishotelView={true} openModal={this.openModal}/>
              </h1>
            </div>
          </div>}
        <div className="row">
          {roomsList}
        </div>
        {this.state.show && <RoomPhotosModal
          ref={node => {
            this.modal = node;
          }}
          roomType={this.state.selectedRoomType}
          show={this.state.show}
          closeModal={this.closeModal}
          hotel={this.props.hotel}
          editRoomtypes={this.props.editRoomtypes}
          addHotelAddRoomType={this.props.addHotelAddRoomType}
          addAddHotelRoomPhoto={this.props.addAddHotelRoomPhoto}
          removeRoomPhoto={this.props.removeRoomPhoto}
          editHotelPhoto={this.props.editHotelPhoto}
          isHotelView={this.props.isHotelView}
          isEditing={true}
          isRoomtypeView={this.state.isRoomtypeView}
        />}

        {this.state.showConfirm && (<Modal show={this.state.showConfirm} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete RoomType</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete member?'}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.handleRemove}
              >
                            Confirm
                          </Button>
              <Button
                bsStyle="success"
                onClick={this.closeModal}
              >
                            Cancel
                          </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
      </div>
    )
  }
}
export default RoomsView


// WEBPACK FOOTER //
// src/routes/hotels/components/RoomsView.js